import { useApolloClient } from '@apollo/client'

import { EnvironmentContext } from 'config/environment'
import { useContext } from 'react'

import Loading from 'modules/core/components/Loading'
import { useEffect } from 'modules/core/hooks/useEffect'
import { signOutAndRedirectToCountryDomain } from 'modules/core/lib/signOutAndRedirectToCountryDomain'

const SignOutPage = () => {
  const client = useApolloClient()
  const { redirectToCountryDomain } = useContext(EnvironmentContext)

  useEffect(() => {
    const signout = async () => {
      client.clearStore()
      signOutAndRedirectToCountryDomain({ redirectToCountryDomain })
    }
    signout()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <Loading />
}

export default SignOutPage
